/**
 * @summary     app.events.js
 * @description Simple eventing
 * @version     1.1
 	> 1.0 Initial version
		- 03/03/2016 CG
	> 1.1 Replaced usage of jQuery since we're using this in non-jQ environments
		- 03/07/2016 SG
 * @file        app.events.js
 ** EXAMPLES:
 ** NOTE:
 ** TODO:
*/

app.addFeature(
	"events",
	function(){
		"use strict";
		var events = {
			list: {}
		};

		events.add = function(eventName) {
			if(!events.list[eventName]) {
				events.list[eventName]={};
			}
		};

		events.emit = function(eventName,obj) {
			let origArgs = arguments;
			if(events.list[eventName]) {
				Object.keys(events.list[eventName]).forEach(
					function(key){
						try {
							let argumentsArray = [obj];

							/*
								NOTE:
									Allow .emit() to have infinite arguments passed in - e.g. app.events.emit('eventName',arg1,arg2,arg3,etc);
							*/
							if(origArgs.length > 2){
								for(let i=2;i < origArgs.length;i++){
									argumentsArray.push(origArgs[i]);
								}
							}

							events.list[eventName][key].apply({},argumentsArray);
						}
						catch(err) {
							console.log(err);
						}
					}
				);
			}
		};

		events.on = function(eventName,id,func) {
			events.add(eventName);
			if(typeof(id) === "string") {
				events.list[eventName][id]=func;
			}
			else {
				func=id;
				events.list[eventName][Math.random()+""]=func;
			}
		};

		events.off = function(eventName,id) {
			events.add(eventName);

			if(typeof(id) === "string") {
				delete events.list[eventName][id];
			}
		};

		return events;
	}
);
